import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Col, Form, Row, Table } from 'react-bootstrap';
import Select from 'react-select';
import { IoMdClose } from 'react-icons/io';
import { authHeader } from '../../../services/auth-header';
import { BASE_URL } from '../../../services/Api';
import debounce from 'lodash/debounce';
import CommonEnquiryFields from '../CommonEnquiryFields';

function PIEdit() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [status, setStatus] = useState('');
    const [enquiryno, setEnquiryno] = useState('');
    const [enquirydate, setEnquirydate] = useState('');
    const [customermaterialcode, setcustomermaterialcode] = useState('');

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productOptions, setProductOptions] = useState([]);
    const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
    const [rows, setRows] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [commonFormData, setCommonFormData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const unitOptions = [
        { value: "", label: "Select UOM" },
        { value: "bot", label: "Bot" },
        { value: "ctn", label: "Ctn" },
        { value: "days", label: "Days" },
        { value: "ft", label: "Ft" },
        { value: "hrs", label: "Hrs" },
        { value: "kg", label: "Kg" },
        { value: "ltr", label: "Ltr" },
        { value: "mtr", label: "Mtr" },
        { value: "nos", label: "Nos" },
        { value: "pil", label: "Pil" },
        { value: "pkt", label: "Pkt" },
        { value: "set", label: "Set" },
        { value: "pcs", label: "Pcs" }
    ];


    const currencyOptions = [
        { value: "", label: "Select Currency" },
        { value: "$ (USD)", label: "USD" },
        { value: "€ (EUR)", label: "EUR" },
        { value: "¥ (JPY)", label: "JPY" },
        { value: "£ (GBP)", label: "GBP" },
        { value: "₹ (INR)", label: "INR" },


    ];

    useEffect(() => {
        const fetchEnquiryData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}purchaseEnquiry/findById/${id}`, {
                    headers: authHeader()
                });

                const enquiryData = response.data;
                console.log("Enquiry Data:", enquiryData);
                setStatus(enquiryData.status || '');
                setEnquiryno(enquiryData.enquiryno || '');
                setEnquirydate(enquiryData.enquirydate || '');
                setcustomermaterialcode(enquiryData.customermaterialcode || '');

                // Set common form data
                setCommonFormData({

                    supplier: {
                        value: enquiryData.supplier.id,
                        label: enquiryData.supplier.companyname,
                        contactperson: enquiryData.contactperson,
                        contactno: enquiryData.contactno,
                        email: enquiryData.email
                    },
                    supplierDetails: {
                        contactperson: enquiryData.contactperson,
                        contactno: enquiryData.contactno,
                        email: enquiryData.email
                    },
                    supplierMultipleAddress: enquiryData.supplierMultipleAddress ? {
                        value: enquiryData.supplierMultipleAddress.id,
                        label: enquiryData.supplierMultipleAddress.supplieraddress
                    } : null,
                    status: enquiryData.status,
                    enquiryno: enquiryData.enquiryno
                });

                // Set product rows
                if (enquiryData.purchaseEnquiryItems && enquiryData.purchaseEnquiryItems.length > 0) {
                    const mappedRows = enquiryData.purchaseEnquiryItems.map(item => ({
                        value: item.product.id,
                        label: `${item.product.description} - ${item.itemcode || ''} - ${item.serialnumber || ''} - ${item.moc || ''} - ${item.product.partno || ''}`,
                        description: item.product.description,
                        itemcode: item.itemcode || '',

                        hsnsacno: item.hsnsacno || item.product.hsnsacno || '',
                        serialnumber: item.serialnumber || '',
                        modelnumber: item.modelnumber || '',
                        tagnumber: item.tagnumber || '',
                        partno: item.partno || '',
                        moc: item.moc || item.product.moc || '',
                        uom: item.uom || item.product.unitofmeasurement || unitOptions[0].value,
                        productremarks: item.productremarks || '',
                        currency: item.currency || currencyOptions[0].value,
                        quantity: item.quantity || ''
                    }));
                    setRows(mappedRows);

                    // Set currency if items exist
                    if (enquiryData.purchaseEnquiryItems[0].currency) {
                        setSelectedCurrency(enquiryData.purchaseEnquiryItems[0].currency);
                    }
                }

                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching enquiry data:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to load enquiry data'
                });
                navigate("/poenquiryindex/1");
            }
        };

        fetchEnquiryData();
    }, [id]);

    const handleProductSearchChange = debounce((inputValue) => {
        setProductSearch(encodeURIComponent(inputValue || " "));
    }, 300);

    const getProductData = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}product/page/ptype/0/10/desc/id/1/Finished,Raw Material, Semi Finished,Services/${productSearch}`,
                { headers: authHeader() }
            );

            const products = response.data?.Index || response.data?.data || [];
            const mapped = products.map(product => ({
                value: product.id,
                label: `${product.description}  - ${product.serialnumber} - ${product.partno}`,
                description: product.description,
                itemcode: product.itemcode,
                partno: product.partno,
                hsnsacno: product.hsnsacno,
                serialnumber: product.serialnumber,
                modelnumber: product.modelnumber,
                tagnumber: product.tagnumber,
                moc: product.moc,
                uom: product.unitofmeasurement || unitOptions[0].value,
            }));

            setProductOptions(mapped);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    useEffect(() => {
        getProductData();
    }, [productSearch]);

    const handleProductChange = (selectedOption) => {
        if (!selectedOption) return;
        setSelectedProduct(selectedOption);

        const newRow = {
            description: selectedOption.description,
            value: selectedOption.value,
            label: selectedOption.label,
            quantity: '',
            hsnsacno: selectedOption.hsnsacno,
            itemcode: selectedOption.itemcode,
            partno: selectedOption.partno,
            serialnumber: selectedOption.serialnumber,
            modelnumber: selectedOption.modelnumber,
            tagnumber: selectedOption.tagnumber,
            moc: selectedOption.moc,
            uom: selectedOption.uom || unitOptions[0].value,
            productremarks: "",
            currency: selectedCurrency || currencyOptions[0].value,
        };

        setRows([...rows, newRow]);
    };

    const handleRowChange = (index, key, value) => {
        const updatedRows = [...rows];
        updatedRows[index][key] = value;
        setRows(updatedRows);
    };

    const handleQuantityChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].quantity = value;
        setRows(updatedRows);
    };

    const removeRow = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
    };

    const validateForm = () => {
        if (!commonFormData.supplier) {
            Swal.fire("Missing Supplier", "Please select a supplier before submitting the form.", "error");
            return false;
        }

        if (!commonFormData.supplierMultipleAddress) {
            Swal.fire("Missing Address", "Please select the supplier's address.", "error");
            return false;
        }

        if (rows.length === 0) {
            Swal.fire("No Products Added", "Please add at least one product to continue.", "error");
            return false;
        }

        for (const row of rows) {
            if (!row.quantity || isNaN(row.quantity) || row.quantity <= 0) {
                Swal.fire(
                    "Invalid Quantity",
                    "Each product must have a valid quantity greater than 0.",
                    "error"
                );
                return false;
            }
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        const {
            supplier,
            supplierDetails,
            supplierMultipleAddress,
        } = commonFormData;

        if (!supplier || !supplierMultipleAddress) {
            Swal.fire({
                icon: 'warning',
                title: 'Please fill the required details!',
                text: 'All fields marked with an asterisk are required.',
            });
            return;
        }

        const purchaseEnquiryItems = rows.map(row => ({
            product: { id: row.value },
            quantity: row.quantity,
            itemcode: row.itemcode || '',
            partno: row.partno || '',
            hsnsacno: row.hsnsacno || '',
            uom: row.uom || '',
            serialnumber: row.serialnumber || '',
            modelnumber: row.modelnumber || '',
            tagnumber: row.tagnumber || '',
            productremarks: row.productremarks || '',
            moc: row.moc || '',
            currency: row.currency,
        }));

        const formData = {
            id: id,
            purchaseEnquiryItems,
            purchaseenquirytype: "Pump Spare",
            purchaseenquirycategory: "International",
            supplier: { id: supplier.value },
            contactno: supplierDetails.contactno,
            contactperson: supplierDetails.contactperson,
            email: supplierDetails.email,
            supplierMultipleAddress: { id: supplierMultipleAddress?.value },
            enquirydate,
            enquiryno,
            customermaterialcode,
            status,
        };

        try {
            await axios.put(`${BASE_URL}purchaseEnquiry/update/${id}`, formData, {
                headers: authHeader()
            });
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Purchase enquiry updated successfully!'
            });
            navigate("/poenquiryindex/1");
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to update enquiry.'
            });
        }
    };

    if (isLoading) {
        return <div className="text-center mt-5">Loading enquiry data...</div>;
    }

    return (
        <div className="container mt-4">
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Enquiry Number: *</Form.Label>
                            <Form.Control
                                type="text"
                                value={enquiryno}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Enquiry Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={enquirydate}
                                onChange={e => setEnquirydate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <CommonEnquiryFields
                    onDataChange={setCommonFormData}
                    initialData={commonFormData}
                />
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="enquiryno">
                            <Form.Label>Customer Material code</Form.Label>
                            <Form.Control
                                type="text"
                                value={customermaterialcode}
                                onChange={(e) => setcustomermaterialcode(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group controlId="currency">
                            <Form.Label>Currency</Form.Label>
                            <Select
                                value={currencyOptions.find(option => option.value === selectedCurrency)}
                                onChange={(selectedOption) => {
                                    setSelectedCurrency(selectedOption.value);
                                    const updatedRows = rows.map(row => ({
                                        ...row,
                                        currency: selectedOption.value
                                    }));
                                    setRows(updatedRows);
                                }}
                                options={currencyOptions}
                                placeholder="Select Currency"
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group controlId="productSelect" className="mb-3">
                    <Form.Label>Add Product</Form.Label>
                    <Select
                        value={selectedProduct}
                        onInputChange={handleProductSearchChange}
                        onChange={handleProductChange}
                        options={productOptions}
                        placeholder="Search or select product"
                        isClearable
                    />
                </Form.Group>

                <div className="table-responsive mt-3">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Product Description</th>
                                <th>Serial No.</th>
                                <th>Model No.</th>
                                <th>Tag No.</th>
                                <th>Part No.</th>
                                <th>MOC</th>
                                <th>HSN Code</th>
                                <th>Product Code</th>
                                <th>Quantity</th>
                                <th>UOM</th>
                                <th>Currency</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        {row.description}
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            value={row.productremarks}
                                            onChange={(e) => handleRowChange(index, 'productremarks', e.target.value)}
                                            placeholder="Remarks"
                                        />
                                    </td>
                                    <td>{row.serialnumber}</td>
                                    <td>{row.modelnumber}</td>
                                    <td>{row.tagnumber}</td>
                                    <td>{row.partno}</td>
                                    <td>{row.moc}</td>
                                    <td>{row.hsnsacno}</td>
                                    <td>{row.itemcode}</td>
                                    <td>
                                        <Form.Control
                                            type="number"
                                            value={row.quantity}
                                            onChange={(e) => handleQuantityChange(index, e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <Select
                                            className='uom'
                                            value={unitOptions.find(option => option.value === row.uom)}
                                            onChange={(selected) => handleRowChange(index, 'uom', selected.value)}
                                            options={unitOptions}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                            }}
                                        />
                                    </td>
                                    <td>
                                        <Select
                                            className='uom'
                                            value={currencyOptions.find(option => option.value === row.currency)}
                                            options={[currencyOptions.find(option => option.value === row.currency)]}
                                            isDisabled
                                        />
                                    </td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => removeRow(index)}
                                        >
                                            <IoMdClose />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>

                <div className="d-flex justify-content-between mt-4 mb-4">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => navigate("/poenquiryindex/1")}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        Update Enquiry
                    </button>
                </div>
            </Form>
        </div>
    );
}

export default PIEdit;